<template>
  <div class="analytics-index">

    <div class="analytics-ul" v-if="!$store.state.project.version || !$store.state.project.version.id">
      <div class="analytics-li" @click="openDialog = true" v-if="$store.state.project.deadline_accounting">
         <span>
           <img src="@/assets/icon/progres-trudoymkost.svg" class="icon-menu"/>
           Диаграмма Ганта
         </span>
        <i class="fas fa-chevron-right"></i>
      </div>

      <router-link
        v-if="$store.state.project.plan && $store.state.project.plan.id"
        :to="`/dashboard/analytics/population`"
        class="analytics-li"
      >
        <span>
          <img src="@/assets/icon/chislennost.svg" class="icon-menu"/>
          Численность
        </span>
        <i class="fas fa-chevron-right"></i>
      </router-link>
      <router-link
        v-else
        :to="`/dashboard/analytics/population-main`"
        class="analytics-li"
      >
        <span>
          <img src="@/assets/icon/chislennost.svg" class="icon-menu"/>
          Численность
        </span>
        <i class="fas fa-chevron-right"></i>
      </router-link>

      <router-link
        :to="`/dashboard/analytics/chess-volume`"
        class="analytics-li"
      >
        <span>
          <i style="font-size: 20px; margin-right: 8px" class="el-icon-s-grid"></i>
          Шахматка - трудоемкость
        </span>
        <i class="fas fa-chevron-right"></i>
      </router-link>

      <router-link
        v-if="$store.getters.permission.price && (!$store.getters.permission.price_ignore || role === 'admin')"
        :to="`/dashboard/analytics/progress`"
        class="analytics-li"
      >
        <span>
          <img src="@/assets/icon/progres-stoimost.svg" class="icon-menu"/>
          Прогресс по проекту - {{
            $store.getters.permission.price && $store.getters.permission.unit_name || 'стоимость'
          }}
        </span>
        <i class="fas fa-chevron-right"></i>
      </router-link>

      <router-link
        v-if="$store.getters.permission.progress"
        :to="`/dashboard/analytics/progress-work`"
        class="analytics-li"
      >
        <span>
           <img src="@/assets/icon/analytics-sharp.svg" class="icon-menu"/>
          Прогресс по проекту - трудоемкость
        </span>
        <i class="fas fa-chevron-right"></i>
      </router-link>

      <router-link
        v-if="$store.getters.permission.progress"
        :to="`/dashboard/analytics/work`"
        class="analytics-li"
      >
          <span>
             <img src="@/assets/icon/p-trudoymkost.svg" class="icon-menu"/>
            Производительность - трудоемкость
          </span>
        <i class="fas fa-chevron-right"></i>
      </router-link>

      <router-link
        v-if="$store.getters.permission.progress && (!$store.state.project.plan || !$store.state.project.plan.id)"
        :to="`/dashboard/analytics/s-curve`"
        class="analytics-li"
      >
          <span>
           <i style="margin-right: 13px; margin-left: 5px">S</i>
           Кривая
          </span>
        <i class="fas fa-chevron-right"></i>
      </router-link>

      <router-link
        :to="`/dashboard/analytics/summary`"
        class="analytics-li"
      >
         <span>
           <img src="@/assets/icon/svodky.svg" class="icon-menu"/>
           Сводки
         </span>
        <i class="fas fa-chevron-right"></i>
      </router-link>
    </div>
    <div v-else class="analytics-ul">
      <div class="analytics-li" @click="openDialog = true" v-if="$store.state.project.deadline_accounting && (!$store.state.project.plan || !$store.state.project.plan.id)">
         <span>
           <img src="@/assets/icon/progres-trudoymkost.svg" class="icon-menu"/>
           Диаграмма Ганта
         </span>
        <i class="fas fa-chevron-right"></i>
      </div>
      <router-link
        v-if="$store.getters.permission.price && (!$store.getters.permission.price_ignore || role === 'admin')"
        :to="`/dashboard/analytics/progress`"
        class="analytics-li"
      >
        <span>
          <img src="@/assets/icon/progres-stoimost.svg" class="icon-menu"/>
          Прогресс по проекту - {{
            $store.getters.permission.price && $store.getters.permission.unit_name || 'стоимость'
          }}
        </span>
        <i class="fas fa-chevron-right"></i>
      </router-link>

      <router-link
        v-if="$store.getters.permission.progress"
        :to="`/dashboard/analytics/progress-work`"
        class="analytics-li"
      >
        <span>
           <img src="@/assets/icon/progres-trudoymkost.svg" class="icon-menu"/>
          Прогресс по проекту - трудоемкость44
        </span>
        <i class="fas fa-chevron-right"></i>
      </router-link>

      <router-link
        v-if="$store.getters.permission.progress"
        :to="`/dashboard/analytics/work`"
        class="analytics-li"
      >
          <span>
             <img src="@/assets/icon/p-trudoymkost.svg" class="icon-menu"/>
            Производительность - трудоемкость
          </span>
        <i class="fas fa-chevron-right"></i>
      </router-link>
    </div>


    <el-dialog
      @close="closeDialog"
      title="Выгрузить отчет"
      :visible.sync="openDialog"
      width="30%"
      center
    >
      <el-form>
        <filter-select
          v-model="modal.period"
          label="Период"
          onlyValue
          :options="optionsPeriod"
        />
      </el-form>
      <el-checkbox v-model="modal.isFact">Факт</el-checkbox>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">Закрыть</el-button>
        <a :href="getHref" target="_blank">
          <el-button type="primary" @click="closeDialog">Выгрузить</el-button>
        </a>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {getRole} from "../../../firestore/permission";
import dayjs from "dayjs";
import {apiUrl, isApiRuleIgnore} from "../../../plugins/firebase";
import firebase from "firebase";
import DatePicker from 'vue2-datepicker';
import FilterSelect from "../../../components/FilterSelect";

export default {
  name: 'Index',
  components: {FilterSelect, DatePicker},
  data() {
    return {
      role: 'worker',
      openDialog: false,
      optionsPeriod: [{
        label: 'Месяц',
        value: 'Месяц'
      }, {
        label: 'Недели',
        value: 'Недели'
      },
        {
          label: 'Дни',
          value: 'Дни'
        }],
      modal: {
        isFact: false,
        period: 'Месяц'
      }
    }
  },
  async mounted() {
    const available_reports = this.$store.state.project.available_reports || {};
    if (this.available_reports) {
      this.available_reports = {
        ...this.available_reports,
        ...available_reports,
      };
    }

    this.role = await getRole(this.$store.state.project.id);
  },
  computed: {
    getHref() {
      let types = {
        'GANT': 'onGenerateJobsPlanByGanttChart',
        'GANT_FACT': 'onGenerateJobsPlanFactByGanttChart',
      };

      if(this.$store.state.project.version && this.$store.state.project.version.id) {
        types = {
          'GANT': 'onGenerateJobsPlanByGanttChart',
          'GANT_FACT': 'onGenerateJobsPlanFactByGanttChart',
        }
      }
      let path = types['GANT']


      if (this.modal.isFact) {
        path = types['GANT_FACT']
      }



      let params = encodeURIComponent(`/${path}/${this.$store.state.project.id}`)
      if (isApiRuleIgnore) {
        params = `/${path}/${this.$store.state.project.id}`
      }
      let url = `${apiUrl}${params}&queryParams=uid=${this.$store.state.company.uid || this.$store.state.company.id || authFirestore.currentUser.uid}`;


      url += `, period=${this.modal.period}`

      if (isApiRuleIgnore) {
        url = url.replace('&queryParams=', '?').replace(/, /g, "&")
      }

      return url
    }
  },
  methods: {
    closeDialog() {
      this.openDialog = false
    }
  }
};
</script>

<style scoped lang="scss">
.analytics-index {
  margin: 0 auto;
  max-width: 400px;
  padding-top: 20px;
}

.analytics-li span {
  display: flex;
  align-items: center;
  color: #000000;
}

.analytics-li {
  img {
    margin-right: 8px;
  }
}

.analytics-ul {
  text-align: left;
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .analytics-li, > > > .analytics-li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    height: 48px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    padding: 0 12px;
    text-decoration: none;
    color: #000;

    &.active {
      background: rgba(54, 118, 203, 0.26) !important;
    }

    &:hover {
      background: #f0f0f0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Analytics/Index.vue